import { render, staticRenderFns } from "./ProfileSocialSharing.vue?vue&type=template&id=98f81718"
import script from "./ProfileSocialSharing.vue?vue&type=script&lang=js"
export * from "./ProfileSocialSharing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports